package com.schoolconnect.app.feature.teachers

import com.schoolconnect.app.domain.SchoolKeys
import com.schoolconnect.app.repository.schoolstaff.SchoolStaffRepository
import kotlinx.coroutines.launch
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.SupervisorJob
import kotlinx.coroutines.cancel
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update

class TeachersViewModel(private val schoolId: String = "") {
    private val scope = CoroutineScope(SupervisorJob() + Dispatchers.Default)
    private val _uiState = MutableStateFlow(TeachersUiState())

    val uiState: StateFlow<TeachersUiState> = _uiState.asStateFlow()

    init {
        refresh()
    }

    fun onEvent(event: TeachersUiEvent) {
        when (event) {
            TeachersUiEvent.BackClicked -> Unit
            TeachersUiEvent.RefreshClicked -> refresh()
            is TeachersUiEvent.SearchChanged -> _uiState.update { it.copy(searchQuery = event.query) }
        }
    }

    private fun refresh() {
        val normalizedSchoolId = schoolId.trim()
        if (normalizedSchoolId.isBlank()) {
            _uiState.update { it.copy(isLoading = false, errorMessage = "A school context is required to load teachers.") }
            return
        }
        _uiState.update { it.copy(isLoading = true, errorMessage = "") }
        scope.launch {
            SchoolStaffRepository.loadSchoolStaffs(normalizedSchoolId, forceRemote = true)
                .onSuccess { staff ->
                    val teachers = staff
                        .filter { it.authRole?.trim() == SchoolKeys.V_ROLE_TEACHER }
                        .mapNotNull { it.name?.trim()?.takeIf(String::isNotBlank) }
                    _uiState.update { it.copy(isLoading = false, errorMessage = "", items = teachers) }
                }
                .onFailure { throwable ->
                    _uiState.update { it.copy(isLoading = false, errorMessage = throwable.message ?: "Unable to load teachers.") }
                }
        }
    }

    fun clear() {
        scope.cancel()
    }
}
